import Icon from '@/components/ui/AppIcon';

interface KPICardProps {
  title: string;
  value: string | number;
  trend: number;
  status: 'success' | 'warning' | 'error';
  icon: string;
  sparklineData: number[];
}

const KPICard = ({ title, value, trend, status, icon, sparklineData }: KPICardProps) => {
  const statusColors = {
    success: 'text-success',
    warning: 'text-warning',
    error: 'text-error',
  };

  const statusBgColors = {
    success: 'bg-success/10',
    warning: 'bg-warning/10',
    error: 'bg-error/10',
  };

  const max = Math.max(...sparklineData);
  const min = Math.min(...sparklineData);
  const range = max - min || 1;

  return (
    <div className="bg-card border border-border rounded-md p-6 shadow-md hover:shadow-lg transition-all duration-250">
      <div className="flex items-start justify-between mb-4">
        <div className="flex items-center gap-3">
          <div className={`flex items-center justify-center w-10 h-10 ${statusBgColors[status]} rounded-md`}>
            <Icon name={icon as any} size={20} className={statusColors[status]} />
          </div>
          <div>
            <h3 className="font-sans text-sm text-text-secondary">{title}</h3>
            <p className="font-data text-2xl font-semibold text-foreground mt-1">{value}</p>
          </div>
        </div>
        <div className={`flex items-center gap-1 px-2 py-1 rounded ${statusBgColors[status]}`}>
          <Icon
            name={trend >= 0 ? 'ArrowUpIcon' : 'ArrowDownIcon'}
            size={14}
            className={statusColors[status]}
          />
          <span className={`font-data text-xs font-medium ${statusColors[status]}`}>
            {Math.abs(trend)}%
          </span>
        </div>
      </div>
      <div className="h-12 flex items-end gap-1">
        {sparklineData.map((value, index) => {
          const height = ((value - min) / range) * 100;
          return (
            <div
              key={index}
              className={`flex-1 ${statusBgColors[status]} rounded-sm transition-all duration-250`}
              style={{ height: `${height}%`, minHeight: '4px' }}
            />
          );
        })}
      </div>
    </div>
  );
};

export default KPICard;